export const StaticModuleConsts = {
    NUMBER_PATTERN: /^-?\d+$/,
    ABOUT_US_PAGE_TITLE: 'World of Sweets - About Us',
    PRIVACY_POLICY_PAGE_TITLE: 'World of Sweets - Privacy Policy',
    TERMS_OF_USE_PAGE_TITLE: 'World of Sweets - Terms Of Use',
};